var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UivModal',_vm._b({model:{value:(_vm.opened),callback:function ($$v) {_vm.opened=$$v},expression:"opened"}},'UivModal',_vm.modalAttrs,false),[(_vm.opened)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }